import { noop } from '@kofno/piper';
import { Cancel, Task } from 'taskarian';
import LearningCollectionEditStore from '..';
import { callApi } from '../../../../../../Appy';
import { currentUserStore } from '../../../../../../CurrentUserStore';
import { findLinkT } from '../../../../../../LinkyLinky';
import { Link } from '../../../../../../Resource/Types';
import { learningCollectionResourceDecoder } from '../../../../Decoders';
import { LearningCollectionResource } from '../../../../Types';
import { LearningCollectionError } from '../../../Types';
import { LoadingForInvitations } from '../Types';

const processLink =
  (learningCollectionId: string) =>
  (link: Link): Task<LearningCollectionError, Link> =>
    Task.succeed<LearningCollectionError, string>(learningCollectionId).map((v) => ({
      ...link,
      href: link.href.replace('{learning_collection_id}', `${v}`),
    }));

const deepLink =
  (learningCollectionId: string) =>
  (links: ReadonlyArray<Link>): Task<LearningCollectionError, Link> =>
    Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(links)
      .andThen(findLinkT('program-deep-link'))
      .andThen(processLink(learningCollectionId));

const loadLearningCollection = (
  state: LoadingForInvitations,
): Task<LearningCollectionError, LearningCollectionResource> =>
  Task.succeed<LearningCollectionError, ReadonlyArray<Link>>(currentUserStore.links)
    .andThen(deepLink(state.id))
    .andThen(callApi(learningCollectionResourceDecoder, {}));

const readyStoreForInvitations =
  (store: LearningCollectionEditStore) =>
  (resource: LearningCollectionResource): Task<LearningCollectionError, void> =>
    Task.succeed(store.readyInvitations(resource));

export const loadForInvitations = (
  state: LoadingForInvitations,
  store: LearningCollectionEditStore,
): Cancel =>
  loadLearningCollection(state)
    .andThen(readyStoreForInvitations(store))
    .fork(store.loadError, noop);
